import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { useEffect } from "react";
import { $createLinkNode } from "@lexical/link";
import { $getSelection, $isRangeSelection, $createTextNode, COMMAND_PRIORITY_LOW, PASTE_COMMAND } from "lexical";

const URL_REGEX =
  /((https?:\/\/)|(www\.))[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;

export function PasteLinkPlugin() {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerCommand(
      PASTE_COMMAND,
      (event) => {
        const clipboardData = (event as ClipboardEvent).clipboardData;
        if (!clipboardData) {
          return false;
        }
        const text = clipboardData.getData("text/plain");
        if (URL_REGEX.test(text)) {
          editor.update(() => {
            const selection = $getSelection();
            if ($isRangeSelection(selection)) {
              const url = text.startsWith("http") ? text : `https://${text}`;
              const linkNode = $createLinkNode(url, { target: "_blank", rel: "noopener noreferrer" });
              linkNode.append($createTextNode(text));
              selection.insertNodes([linkNode]);
            }
          });
          event.preventDefault();
          return true;
        }
        return false;
      },
      COMMAND_PRIORITY_LOW
    );
  }, [editor]);

  return null;
}
